// Core utility functions - $ returns single element, $$ returns array
export const $ = (selector, context = document) => context.querySelector(selector);
export const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

export const isReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Safari-compatible logging - empty error function to match old working script
const Logger = {
  error: (message, error = null, context = 'Unknown') => {
    // Empty function to match old working script - Safari treats console.error as fatal
  },
  warn: (message, context = 'Unknown') => {
    console.warn(`[${context}] ${message}`);
  },
  info: (message, context = 'Unknown') => {
    console.info(`[${context}] ${message}`);
  },
};

// Safe initialization wrapper matching old script exactly
export const safeInit = (module, moduleName) => {
  try {
    module.init();
    return true;
  } catch (error) {
    return false;
  }
};

// Error boundary matching old working script structure exactly
export const ErrorBoundary = {
  setupGlobalErrorHandling() {
    // Exact pattern from old working script - comma operator pattern
    window.addEventListener('error', event => (event.message, event.error, event.preventDefault(), true));
    window.addEventListener('unhandledrejection', event => {event.reason, event.preventDefault()});
  },

  withFallback: (fn, fallback = () => null, context = 'Unknown') => (...args) => {
    try {
      return fn(...args);
    } catch (error) {
      return fallback(...args);
    }
  },

  async withRetry(fn, maxRetries = 3, delay = 1000, context = 'Unknown') {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        if (attempt === maxRetries) throw Logger.error(0, error, context), error;
        await new Promise(resolve => setTimeout(resolve, delay * attempt));
      }
    }
  },
};

export { Logger };

